// src/layouts/AdminLayout.js
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import AdminSidebar from '../components/AdminSidebar';




export default function AdminLayout() {
  const { pathname } = useLocation();
  const collapseSidebar = pathname.startsWith('/admin/flow/');
  return (
    <div className="container-fluid admin-layout">
      <div className="d-flex">
        <AdminSidebar collapsed={collapseSidebar /*|| collapseOnMobile*/} />

        {/* `admin-content` carries `min-width: 0`. Without it this flex item keeps its automatic
            minimum size, so one wide child — a table that scrolls inside itself — makes the whole
            page wider than the window instead: a horizontal scrollbar on the window, a vertical
            one behind it, and a table that never scrolls because it was given all the room it
            asked for. */}
        <div className="flex-grow-1 shaded-bg admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
